interface SchemaOrgProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'FAQPage' | 'Article';
  data?: Record<string, unknown>;
}

export default function SchemaOrg({ type, data = {} }: SchemaOrgProps) {
  const schemas: Record<string, Record<string, unknown>> = {
    Organization: {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '韩漫天堂',
      url: 'https://hanmantiantang.com',
      description: '韩漫天堂是国内领先的韩国漫画在线阅读平台，提供海量免费韩国漫画资源。',
      email: 'contact@hanmantiantang.com',
      telephone: '+86-400-888-8888',
      address: {
        '@type': 'PostalAddress',
        streetAddress: '望京SOHO T2 12层',
        addressLocality: '北京',
        addressRegion: '朝阳区',
        addressCountry: 'CN',
      },
      sameAs: [
        'https://weibo.com/hanmantiantang',
        'https://space.bilibili.com/hanmantiantang',
      ],
      ...data,
    },
    WebSite: {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: '韩漫天堂',
      url: 'https://hanmantiantang.com',
      description: '韩漫天堂汇集海量韩国漫画资源，提供免费在线阅读服务。涵盖恋爱、奇幻、动作、悬疑等多种题材。',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://hanmantiantang.com/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
      ...data,
    },
    WebPage: {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: '韩漫天堂',
      url: 'https://hanmantiantang.com',
      description: '韩漫天堂 - 免费韩国漫画在线阅读平台',
      ...data,
    },
    FAQPage: {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      ...data,
    },
    Article: {
      '@context': 'https://schema.org',
      '@type': 'Article',
      ...data,
    },
  };

  const schema = schemas[type];
  if (!schema) return null;

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}